"use client";

import ColletteReadMoreToggle from "./collette-read-more-toggle";

export default ColletteReadMoreToggle;
